module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"ticket_drone_detail.history":"History","ticket_drone_detail.notes":"Notes","ticket_drone_detail.lot_note":"บันทึกจาก Lot"}}')
  delete Component.options._Ctor
}
